import process from "node:process";
import type { AppMeta } from "@calcom/types/App";

export const metadata = {
  name: "Slad Video",
  description:
    "Slad Video is the in-house web-based video conferencing platform powered by Daily.co, which is minimalistic and lightweight, but has most of the features you need.",
  installed: !!process.env.DAILY_API_KEY,
  type: "daily_video",
  variant: "conferencing",
  url: "https://daily.co",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Slad",
  category: "conferencing",
  slug: "daily-video",
  title: "Slad Video",
  isGlobal: true,
  email: "help@getslad.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Slad Video",
    },
  },
  key: { apikey: process.env.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: false,
} as AppMeta;

export default metadata;
